import { useState as h, useMemo as s, useEffect as x } from "react";
import { getCellTime as d } from "./atoms-v259.js";
import { getCellValue as J } from "./atoms-v260.js";
import { getCellUID as p } from "./atoms-v261.js";
import { getDifferenceInDays as M } from "./atoms-v262.js";
import { getStartingCellIdx as Q, getStartingCellData as X, getEndingCellData as Z, getEndOfActiveRangeCell as $, getEndOfActiveRangeCellData as Y, getIntegratedDataStoreActionableKeys as D, getSelectedCells as I, getConsideredCells as U, getCellsDisabledByMinSelectionBounds as ee, getCellsDisabledByMaxSelectionBounds as ne, getCheckoutDateCell as ie, validateDefaultSelection as te } from "./atoms-v21178.js";
function fe({
  calendarYearConfigs: K,
  dataStore: y,
  defaultSelection: A,
  onEmitNotification: O,
  onInternalError: B,
  onSelectionChange: H
}) {
  const [l, L] = h(
    /* @__PURE__ */ new Map()
  ), [u, N] = h([]), [C, E] = h(null), [o, a] = h(p(A[0])), [t, m] = h(p(A[1])), S = s(
    () => Q(o, u),
    [u, o]
  ), n = s(
    () => X(o, l),
    [l, o]
  ), f = s(
    () => Z(t, l),
    [l, t]
  ), g = s(
    () => $(o, t, C),
    [o, t, C]
  ), P = s(
    () => Y(g, l),
    [l, g]
  ), v = s(
    () => D(
      S,
      n,
      u
    ),
    [S, n, u]
  ), k = s(
    () => I(t, v),
    [t, v]
  ), b = s(
    () => U(f, g, v),
    [f, g, v]
  ), w = s(
    () => ee(
      S,
      n,
      u
    ),
    [S, n, u]
  ), R = s(
    () => ne(
      S,
      n,
      u
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n, u]
  ), T = s(() => b.length ? b.every((e) => {
    var i;
    const c = (i = l.get(e)) == null ? void 0 : i.cellData;
    return c == null ? void 0 : c.available;
  }) : !0, [b, l]), j = s(() => [...w || [], ...R || []], [w, R]), V = s(
    () => ie(
      o,
      n,
      v,
      l
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [o]
  );
  x(() => {
    if (!y.size || !K.length)
      return;
    const e = /* @__PURE__ */ new Map();
    for (const c of K)
      for (const i of c.month.weeks)
        for (const r of i.dates)
          r.isPreviousMonth || r.isNextMonth || e.set(r.cellUID, {
            ...r,
            cellData: y.get(r.cellUID) ?? null
          });
    L(() => e), N(() => Array.from(e.keys()));
  }, [y]), x(() => {
    let e = null, c = null;
    n && (e = new Date(n.year, n.month, n.day)), t && f ? c = new Date(f.year, f.month, f.day) : t && (c = J(t));
    const r = {
      hasError: k.filter(
        (_) => {
          var z;
          return !!y.get(_) && ((z = y.get(_)) == null ? void 0 : z.available);
        }
      ).length !== k.length,
      selection: [e, c]
    };
    H(r);
  }, [n, f]), x(() => {
    const { error: e, isReady: c, isValid: i, nextSelection: r } = te(
      l,
      o,
      t
    );
    if (!i && c) {
      if (e)
        return B == null ? void 0 : B(Error("No contiguous availability"));
      W(r);
    }
  }, [l]);
  function q(e, c) {
    var r;
    const i = (r = l.get(e)) == null ? void 0 : r.cellData;
    if (i) {
      if (e === V) {
        m(e);
        return;
      }
      if (!o) {
        a(e), m(null), i.minSelection && i.minSelection > 1 && O({
          args: {
            minStay: i.minSelection
          },
          type: "min-stay"
        });
        return;
      }
      if (d(e) < d(o)) {
        a(e), i.minSelection && i.minSelection > 1 && O({
          args: {
            minStay: i.minSelection
          },
          type: "min-stay"
        });
        return;
      }
      if (d(e) === d(o)) {
        a(null), m(null);
        return;
      }
      if (t && (n != null && n.minSelection) && M(e, o) < (n == null ? void 0 : n.minSelection) && (!(i != null && i.minSelection) || M(t, e) >= (i == null ? void 0 : i.minSelection))) {
        a(e);
        return;
      }
      if (t && d(e) < d(t) && (!(n != null && n.minSelection) || M(e, o) >= (n == null ? void 0 : n.minSelection))) {
        m(e);
        return;
      }
      if (t && d(e) > d(t)) {
        a(e), m(null);
        return;
      }
      if (!(n != null && n.minSelection) || M(e, o) >= (n == null ? void 0 : n.minSelection)) {
        m(e);
        return;
      }
    }
  }
  function F(e) {
    E(e);
  }
  function G(e) {
    E(null);
  }
  function W(e) {
    e || (e = A), a(p(e[0])), m(p(e[1]));
  }
  return {
    checkoutDateCell: V,
    consideredCells: b,
    disabledByMaxSelectionBoundsCells: R,
    disabledByMinSelectionBoundsCells: w,
    disabledBySelectionBoundsCells: j,
    endingCell: t,
    endingCellData: f,
    endOfRangeActiveCell: g,
    endOfRangeActiveCellData: P,
    hoveredCell: C,
    integratedDataStore: l,
    integratedDataStoreKeys: u,
    isConsideredRangeAvailable: T,
    onCellClick: q,
    onCellMouseEnter: F,
    onCellMouseLeave: G,
    reset: W,
    selectedCells: k,
    startingCell: o,
    startingCellData: n
  };
}
export {
  fe as useUserInteractions
};
